
import { computed, defineComponent,onMounted,onActivated,onUpdated, reactive,ref,getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import screenfull from "screenfull";
import { resetPassWord,checkUserName,resetUserName } from "@/api/login/index";
import VXETable from "vxe-table";
import { ElMessageBox } from 'element-plus'

export default defineComponent({
    setup() {
        const store = useStore();
        const router = useRouter();
        let userName = window.sessionStorage.getItem("name");
        let state: any = reactive({
            crumbList: computed(() => store.getters.getCrumbList),
            isSidebarNavCollapse: computed(
                () => store.getters.getIsSidebarNavCollapse
            ),
        });
        let toggleNavCollapse = () => {
            store.commit("toggleNavCollapse");
        };
        let full = () => {
            screenfull.isEnabled && screenfull.toggle();
        };
        let loginOut = () => {
            ElMessageBox({
                title:'提示',
                message:'您将退出本系统，是否继续？',
                type:'info',
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(action => {
                if (action === 'confirm') {
                    window.sessionStorage.removeItem("token");
                    router.replace({ path: "/login" });
                }
            });
        };

        let updatePassWord = () => {
            updatePswFormVisible.value = true;
        };


        let updatePswFormVisible = ref(false);

        let updatePswForm = {
            oldPsw: "",
            newPsw: "",
            confirmPsw: "",
        };


        // 表单dom
        let pass_form = ref(null);
        // 窗口关闭
        let modal_close = ()=>{
            updatePswFormVisible.value = false;
        };
        let validateUsername = async ({ itemValue, rule, rules, data, property }:any) => {
            let res:any = await checkUserName(itemValue);
            if(!!res.data) {
                return new Error("用户名已经被占用");
            }
        };
            //设置属性
        let updatePswFormRules = reactive({
            userName: [
                { required: true, message: "请输入新用户名", trigger: "blur" },
                { validator: validateUsername, message: "用户名已被占用"}
                ],
            oldPsw: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
            newPsw: [{ required: true, message: "请输入新密码", trigger: "blur" }],
            confirmPsw: [
                { required: true, message: "请确认新密码", trigger: "blur" }
            ],
        });
        let submitForm = () => {
            resetPassWord(updatePswForm).then((res: any) => {
                if (res.code == 0) {
                    updatePswFormVisible.value = false;
                    VXETable.modal.message({ content: "修改成功", status: "success" });
                }
            });
        };

        let setUserNameFormVisible = ref(false);
        const setUserNameFormRef = ref();
        let setUserNameForm = reactive({
            userName: "",
            newPsw: "",
            confirmPsw: "",
        });
        let userName_form = ref(null);
        // 窗口关闭
        let userName_modal_close = ()=>{
            setUserNameFormVisible.value = false;
        };
        let submitUserNameForm = () => {
            setUserNameFormRef.value.validate((valid: any) => {
                if (!valid ||  Object.keys(valid).length === 0) {
                    resetUserName(setUserNameForm).then((res: any) => {
                        if (res.code == 0) {
                            setUserNameFormVisible.value = false;
                            VXETable.modal.message({ content: "设置成功", status: "success" });
                            window.sessionStorage.setItem("name", res.data.userName);
                            window.sessionStorage.setItem("currentUser",  JSON.stringify(res.data));
                        }
                    });
                } else {
                    console.log('error submit')
                    return false
                }
            })
        };
        onMounted(() => {
            try{
                let currentUser:any = JSON.parse(window.sessionStorage.getItem("currentUser")|| '');
                let subUserId:string = window.sessionStorage.getItem("subUserId")||'';
                if(!subUserId && currentUser && currentUser['state'] === '2'){
                    setUserNameFormVisible.value = true;
                }
            }catch (e) {

            }

        });
        return {
            state,
            loginOut,
            full,
            userName,
            toggleNavCollapse,
            updatePassWord,
            updatePswForm,
            updatePswFormVisible,
            updatePswFormRules,
            submitForm,
            pass_form,
            modal_close,

            setUserNameFormVisible,
            setUserNameFormRef,
            setUserNameForm,
            userName_form,
            userName_modal_close,
            submitUserNameForm,

        };
    },
});
